export const shortRs = (t) => (t ? t.replace(/(\d{1,3}),000\b/g, "$1k").replace(/–\s?Rs\s?/g, "–") : "—");
export const fmtRs = (n) => (n == null ? "—" : `Rs ${n.toLocaleString("en-US")}`);
export const FC_RANK = { Low: 0, "Low–Medium": 1, Medium: 2, "Medium–High": 3, High: 4 };
export const REVENUE_DISCLAIMER = "Revenue estimates are indicative gross-sales projections based on simplified business assumptions. Actual results depend on pricing, demand, capacity, competition and execution.";

export const TYPE_OPTS = [["online", "Online"], ["local", "Local service"], ["product", "Selling products"], ["b2b", "Working with businesses"], ["consumer", "Working with consumers"]];
const typeMatch = (idea, k) => (k === "local" ? idea.tags?.local && idea.tags?.service : idea.tags?.[k]);

export function fitReasons(idea, p) {
  if (!p) return [];
  const out = [];
  if (p.budget && idea.startup_low != null && idea.startup_low <= p.budget) out.push(`Fits your ${fmtRs(p.budget)} budget`);
  if ((p.weekends || p.time === "weekends") && idea.tags?.weekend) out.push("Can be done on weekends");
  if (p.time === "evenings" && idea.tags?.evenings) out.push("Works with evening availability");
  if (p.time === "flexible" && idea.tags?.flexible) out.push("Fits a flexible schedule");
  if (p.skill === "beginner" && idea.difficulty === "Beginner") out.push("Beginner friendly");
  (p.types || []).filter((k) => typeMatch(idea, k)).forEach((k) => out.push(`Matches your preference: ${TYPE_OPTS.find((t) => t[0] === k)?.[1].toLowerCase()}`));
  if (p.fast_revenue === "very" && FC_RANK[idea.first_customer_difficulty] <= 1) out.push("First customers may be easier to find");
  return out;
}

export function scoreIdea(idea, p) {
  if (p.budget && (idea.startup_low ?? 0) > p.budget) return -1;
  let s = 0;
  const timeTag = { weekends: "weekend", evenings: "evenings", flexible: "flexible", full_time: "full_time" }[p.time];
  if (timeTag && idea.tags?.[timeTag]) s += 2;
  (p.types || []).forEach((k) => { if (typeMatch(idea, k)) s += 2; });
  if (p.skill === "beginner") s += idea.difficulty === "Beginner" ? 2 : idea.difficulty === "Beginner–Intermediate" ? 1 : -2;
  if (p.skill === "intermediate" && idea.difficulty !== "Beginner") s += 1;
  const fc = FC_RANK[idea.first_customer_difficulty] ?? 2;
  if (p.fast_revenue === "very") s += fc <= 1 ? 2 : fc >= 3 ? -1 : 0;
  if (p.fast_revenue === "somewhat" && fc <= 2) s += 1;
  if (p.weekends && idea.tags?.weekend) s += 1;
  return s;
}
